// extracted by mini-css-extract-plugin
export var actionText = "_ll-4";
export var container = "_ll-0";
export var leftSection = "_ll-1";
export var rightSection = "_ll-2";
export var settingsButton = "_ll-6";
export var settingsIcon = "_ll-7";
export var shortcut = "_ll-5";
export var shortcutGroup = "_ll-3";